/* Custom product carousel — scroll-snap slider with prev/next + page counter (1/N). */
class ProductCarousel extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-track]');
    this.prevBtn = this.querySelector('[data-prev]');
    this.nextBtn = this.querySelector('[data-next]');
    this.current = this.querySelector('[data-current]');
    this.total = this.querySelector('[data-total]');
    if (!this.track) return;

    this.onPrev = () => this.page(-1);
    this.onNext = () => this.page(1);
    this.onScroll = () => {
      if (this._raf) return;
      this._raf = requestAnimationFrame(() => { this._raf = null; this.update(); });
    };

    this.prevBtn && this.prevBtn.addEventListener('click', this.onPrev);
    this.nextBtn && this.nextBtn.addEventListener('click', this.onNext);
    this.track.addEventListener('scroll', this.onScroll, { passive: true });
    window.addEventListener('resize', this.onScroll);

    this.update();
  }

  page(dir) {
    this.track.scrollBy({ left: dir * this.track.clientWidth, behavior: 'smooth' });
  }

  update() {
    var pageW = this.track.clientWidth || 1;
    var totalPages = Math.max(1, Math.round(this.track.scrollWidth / pageW));
    var cur = Math.min(totalPages, Math.round(this.track.scrollLeft / pageW) + 1);
    if (this.current) this.current.textContent = cur;
    if (this.total) this.total.textContent = totalPages;
    var atStart = this.track.scrollLeft <= 4;
    var atEnd = this.track.scrollLeft + pageW >= this.track.scrollWidth - 4;
    if (this.prevBtn) this.prevBtn.disabled = atStart;
    if (this.nextBtn) this.nextBtn.disabled = atEnd;
  }

  disconnectedCallback() {
    this.prevBtn && this.prevBtn.removeEventListener('click', this.onPrev);
    this.nextBtn && this.nextBtn.removeEventListener('click', this.onNext);
    this.track && this.track.removeEventListener('scroll', this.onScroll);
    window.removeEventListener('resize', this.onScroll);
  }
}

if (!customElements.get('product-carousel')) {
  customElements.define('product-carousel', ProductCarousel);
}
